import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import * as actions from '../_redux/userDetailsActions';
import {useDispatch} from 'react-redux';
import { Modal } from 'react-bootstrap';
import ListFileVersions from './ListFileVersions';

const PopupViewVersions = ({
                             id,
                             fileName,
                             fileExtension
                           }) => {
  const dispatch = useDispatch();
  const [fileVersions, setFileVersions] = useState([]);
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const showContent = () => {
    dispatch(actions.listFileVersions({uniqueId: id}))
      .then((versions) => {
        const data = Array.isArray(versions) ? versions : [];
        setFileVersions(data);
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  return (
    <>
      <Button
        variant="outline-primary"
        className="d-flex align-items-center justify-content-between m-0 custom-button-primary"
        onClick={() => {
          handleShowModal();
          showContent();
        }}
      >
        <img
          src={toAbsoluteUrl('/media/svg/file-versions.svg')}
          alt="view list versions"
        />
      </Button>
      <Modal
        className="custom-modal-container"
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <div>
            <img
              onClick={handleCloseModal}
              className="modal-close-button"
              src={toAbsoluteUrl('/media/svg/Error-circle.svg')}
              alt="close modal"
            />
            <ListFileVersions
              data={fileVersions}
              fileName={fileName}
              id={id}
              fileExtension={fileExtension}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

PopupViewVersions.propTypes = {
  id: PropTypes.string,
  fileName: PropTypes.string,
  fileExtension: PropTypes.string
};

export default PopupViewVersions;
